"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M13 12.5h1.5V14H13zm0-2.5h1.5v1.5H13z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M21 3H3v18h18zM10 15H8.5v-4.5H7V9h3zm6-1c0 .55-.45 1-1 1h-2.5c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1H15c.55 0 1 .45 1 1z"
}, "1")], 'EighteenUpRatingSharp');